import { render } from "./ToolButtonWithMenu.vue?vue&type=template&id=40b5681f&scoped=true&ts=true"
import script from "./ToolButtonWithMenu.vue?vue&type=script&lang=ts"
export * from "./ToolButtonWithMenu.vue?vue&type=script&lang=ts"

import "./ToolButtonWithMenu.vue?vue&type=style&index=0&id=40b5681f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40b5681f"]])

export default __exports__